import { useIntl, defineMessages } from 'react-intl'
import { Box, Text, Button, Icon, Flex } from '@homebotapp/hb-react-component-catalog'
import { formatCurrency } from '../../../../../helpers/formatters'
import { HOMEOWNER_DIGEST_INTEREST_MODULE } from '../../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MSG = defineMessages({
  headline: {
    id: 'PaidExtra.headline',
    defaultMessage: "You're paying principal ahead of schedule!"
  },
  message: {
    id: 'PaidExtra.message',
    defaultMessage: 'extra paid so far'
  },
  button: {
    id: 'PaidExtra.button',
    defaultMessage: 'Update your balance'
  }
})

interface PaidExtraProps {
  principalDiff: number
  onClick: () => void
}

export const PaidExtra = ({ principalDiff, onClick }: PaidExtraProps) => {
  const intl = useIntl()
  const handleOnClick = () => {
    onClick()
  }

  return (
    <Box
      data-qa='paid-extra-box'
      display='flex'
      gap='6'
      borderRadius='.75rem'
      paddingX='8'
      paddingY='6'
      marginTop='8'
      justifyContent='space-between'
      // @ts-ignore
      backgroundColor='var(--brand-surface-layer-50)'
      flexDirection='column'
    >
      <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
        <Flex mb='2'>
          <Text as='span' textAlign='center'>
            {intl.formatMessage(MSG.headline)}
          </Text>
        </Flex>
        <Flex alignItems='center' mb='1'>
          <Icon marginEnd='2' name='check-circle' color='success.500' />
          <Text color='success' size='sm' as='span' me='1' textAlign='left'>
            {formatCurrency(Math.round(principalDiff))}
          </Text>
          <Text size='sm' as='span' textAlign='left'>
            {intl.formatMessage(MSG.message)}
          </Text>
        </Flex>
      </Box>
      <Box display='flex' justifyContent='center' alignItems='center'>
        <Button
          data-qa='update-balance-button'
          tracking={{
            guid: 'EdM3Q86lhkJze00X4JFR5S',
            ui_context: HOMEOWNER_DIGEST_INTEREST_MODULE,
            descriptor: MSG.button.defaultMessage
          }}
          onClick={handleOnClick}
          leftIcon={<Icon name='pencil' />}
          size='sm'
        >
          {intl.formatMessage(MSG.button)}
        </Button>
      </Box>
    </Box>
  )
}
